import * as React from 'react';

import assertions from 'lib/assertions';
import FormElement from 'components/FormElement';
import Select from 'components/Select';

import { AdminNewAutoMessageOrgs_organizations_admins } from './queries/__generated__/AdminNewAutoMessageOrgs';
import { AutoMessageSenderInput } from 'globalTypes';

type Props = {
  handleSenderChange: (sender: AutoMessageSenderInput | undefined) => void;
  value?: string;
  admins: AdminNewAutoMessageOrgs_organizations_admins[];
};

export default function AdminNewAutoMessageComposeIndividualSender(props: Props) {
  const adminOptions = props.admins.map(
    admin => (admin ? { label: admin.name, value: admin.uuid } : null)
  );

  return (
    <FormElement
      label="Sender"
      element={Select}
      validate={value => assertions.notEmpty(value, 'Please select an administrator')}
      onValidChange={value => props.handleSenderChange({ uuid: value, type: 'user' })}
      onInvalidChange={() => props.handleSenderChange(undefined)}
      subtext="This message will be sent with the administrator’s name. Recipients can reply to this message if the chosen administrator has replies enabled in their account settings."
      elementProps={{
        value: props.value,
        placeholder: 'Choose an administrator',
        name: 'sender',
        options: adminOptions.filter(option => option),
        searchable: true,
      }}
    />
  );
}
